import { Stack } from '../../../../design-system/stack/stack';
import { AccountView, CardView } from '../../../../types/entity-types';
import { getAccountDisplayName } from '../../../../utils/accounts/get-account-display-name';
import { formatBillingAddress } from '../../utils/format-billing-address';
import { CardDetailsRow } from './card-details-row';

type CardDetailsProps = {
  card: CardView;
  accounts: AccountView[];
};

export const CardDetails = ({ card, accounts }: CardDetailsProps) => {
  const cardholderName = `${card.holderFirstName} ${card.holderLastName}`.trim();
  const account = accounts.find((a) => a.id === card.accountId);
  const accountName = account ? getAccountDisplayName(account) : 'Unknown';
  const billingAddress = formatBillingAddress(card.holderBillingAddress);

  return (
    <Stack space={4} className="rounded-lg border border-border p-4">
      <CardDetailsRow label="Spent this month" value="—" />
      <CardDetailsRow label="Cardholder" value={cardholderName} />
      <CardDetailsRow label="Account" value={accountName} />
      <CardDetailsRow label="Billing address" value={billingAddress} multiline />
    </Stack>
  );
};
